export const typeDefs = `
  type Mutation {

  }

  type Query {

  }
`;
